import breakpoints from './breakpoints';
import GlobalStyles from './Global';

export { breakpoints, GlobalStyles };
